<form [formGroup]="formGroup" class="legacy-form">
    <div class="content-inner">
        <div class="inner-border">
            <span class="subtitle">User Information</span>
            <div class="form-group">
                <span class="label">First Name </span>
                <input #firstName [formControlName]="firstNameControlName" [id]="firstNameControlName" type="text"
                    (change)="onFirstNameChanged(firstName)" />
                <span *ngIf="showFirstNameError" class="validation-error">{{ firstNameErrorMessage }}</span>
            </div>
            <div class="form-group">
                <span class="label">Last Name </span>
                <input #lastName [formControlName]="lastNameControlName" [id]="lastNameControlName" type="text"
                    (change)="onLastNameChanged(lastName)" />
                <span *ngIf="showLastNameError" class="validation-error">{{ lastNameErrorMessage }}</span>
            </div>
            <div class="form-group">
                <span class="label">Email </span>
                <input #email
                    [formControlName]="emailControlName" 
                    [id]="emailControlName" 
                    type="email"
                    (change)="onEmailChanged(email)" (focusout)="onEmailExist(email.value)"/>
                <span *ngIf="showEmailError" class="validation-error">{{ emailErrorMessage }}</span> 
                <span *ngIf="!showEmailError && formGroup.get('email').hasError('pattern') && formGroup.get('email').touched" class="validation-error">You have entered an invalid email address. Please correct the email address and try again.</span> 
                <span *ngIf="formGroup.get('email').hasError('duplicate')" class="validation-error"> This email already exists in the system. </span> 
            </div>
            <div class="form-group">
                <span class="label">Job Title</span>
                <input #jobTitle [formControlName]="jobTitleControlName" [id]="jobTitleControlName" type="text"
                    (change)="onJobTitleChanged(jobTitle)" />
                <span *ngIf="showJobTitleError" class="validation-error">{{ jobTitleErrorMessage }}</span>
            </div>
            <div class="form-group">
                <span class="label">Hire Date</span>
                <input 
                    [formControlName]="hireDateControlName" 
                    [id]="hireDateControlName" 
                    type="date"
                    (change)="onHireDateChanged($event)"  onkeydown="return false" class="w-200"/>
            </div>
            <div class="form-group">
                <span class="label">Employee ID</span>
                <input #employeeId [formControlName]="employeeIdControlName" [id]="employeeIdControlName" type="text"
                    (change)="onEmployeeIdChanged(employeeId)" />
                <span *ngIf="showEmployeeIdError" class="validation-error">{{ employeeIdErrorMessage }}</span>
            </div>
           
            <div class="form-group">
                <span class="label">SSO Name ID</span>
                <input #ssoNameId [formControlName]="ssoNameIdControlName" [id]="ssoNameIdControlName" type="text"
                    (change)="onSsoNameIdChanged(ssoNameId)" />
                <span *ngIf="showSsoNameIdError" class="validation-error">{{ ssoNameIdErrorMessage }}</span>
            </div>
            <div class="form-group">
                <span class="label">User Role </span>
                <select #userRole [formControlName]="userRoleControlName" [id]="userRoleControlName"
                    (change)="onUserRoleChanged(userRole)">
                    <option *ngFor="let role of editableUserRoles" [value]="role.roleName">{{ role.friendlyName }}
                    </option>
                </select>
                <span *ngIf="showUserRoleError" class="validation-error">{{ userRoleErrorMessage }}</span>
            </div>
            <div class="form-group sub-group">
                <span class="subtitle">Status</span>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <span class="label">Status </span>
                            <select #status [formControlName]="statusControlName" [id]="statusControlName"
                                (change)="onStatusChanged(status)">
                                <option [value]="true">Active</option>
                                <option [value]="false">Inactive</option>
                            </select>
                            <span *ngIf="showStatusError" class="validation-error">{{ statusErrorMessage }}</span>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <span class="label">Sync Status </span>
							<span class="material-symbols-outlined icon-sync-status-success" *ngIf="activeUser.upsertStatus">check_circle</span>
                            <span class="material-symbols-outlined icon-sync-status-error" *ngIf="!activeUser.upsertStatus">error</span>

                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <span class="label">Last Login </span>
                            <span class="label">{{ activeUser.lastSuccessfulLoginDate | date :'MM/dd/yyyy h:mm:ss a' }}
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <label *ngIf="isEditing" for="isLockedOut">
                        <input #isLockedOut [formControlName]="isLockedOutControlName" [id]="isLockedOutControlName"
                            type="checkbox" (change)="onIsLockedOutChanged(isLockedOut)">
                        {{ isLockedOutLabelText }}
                    </label>
                </div>
                <div>
                    <label *ngIf="isEditing && isShowDormant" for="isDormant">
                        <input #isDormant [formControlName]="isDormantControlName" [id]="isDormantControlName"
                            type="checkbox" (change)="onIsDormantChanged(isDormant)">
                        Is Dormant
                    </label>
                </div>
                <div>
                    <label *ngIf="isEditing && (isLoginMethodNone() || activeUser.isNonSSOUser)">
                        <input #forcePasswordReset [formControlName]="forcePasswordResetControlName"
                            [id]="forcePasswordResetControlName" type="checkbox"
                            (change)="onForcePasswordResetChanged(forcePasswordReset)">
                        Force Password Reset
                    </label>
                </div><br>
            </div>
            <div class="form-group" *ngIf="!isLoginMethodNone()">
                <span class="label">SSO User </span>
                <select #ssoUser [formControlName]="ssoUserControlName" [id]="ssoUserControlName"
                    (change)="onSsoUserChanged(ssoUser)">
                    <option [value]="false">Yes</option>
                    <option [value]="true">No</option>
                </select>
            </div>
            <div class="form-group" *ngIf="_userAdminService.ClientsWithApplications.length > 0">
                <span class="subtitle">Clients</span>
                <ng-container *ngFor="let client of _userAdminService.ClientsWithApplications">
                    <input #newUserApp [formControlName]="getClientControlName(client.client.id)"
                        [id]="getClientControlName(client.client.id)"
                        (change)="onClientCheckChanged(newUserApp, client.client.id)" type="checkbox">
                    <label>{{ client.client.name }}</label>
                    <br />
                </ng-container>
                <div>
                    <br />
                </div>
                <div class="form-group" *ngIf="_userAdminService.UserClients?.length > 0">
                    <div *ngFor="let client of _userAdminService.UserClients; let cIndex = index">
                        <div *ngIf="_userAdminService && 
                                    _userAdminService.ClientsWithApplications && 
                                    _userAdminService.ClientsWithApplications.length > 0 && 
                                    _userAdminService.ClientsWithApplications[client.index] && 
                                    _userAdminService.ClientsWithApplications[client.index].clientApplications">
                            <div>
                                <span class="subtitle">Applications for {{client.client.name}}</span>
                                <div class="form-group">
                                    <fieldset *ngIf="anyActiveClientApplications(client.client.id)">
                                        <legend> Active</legend>
                                        <div *ngFor="let application of applications; let ind= index ">
                                            <div
                                                *ngFor="let clientAppModel of _userAdminService.ClientsWithApplications[client.index].clientApplications;">
                                                <div
                                                    *ngIf="application.id == clientAppModel.applicationId
                                                    && clientAppModel.isActive && clientAppModel.isPurchased
                                                    && application.id != 0 && checkUserApplicationMappingStatus(clientAppModel.clientId, application.id)">
                                                    <label class="compact application list">
                                                        <input #newUserApp
                                                            [formControlName]="getApplicationControlName(client.client.id, application.id)"
                                                            [id]="getApplicationControlName(client.client.id, application.id)"
                                                            (change)="userApplicationChecked(newUserApp, undefined, clientAppModel, cIndex)"
                                                            [value]="application.id" type="checkbox"
                                                            [checked]="isApplicationChecked(clientAppModel)">
                                                        {{ application.name }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <div *ngIf="!anyActiveClientApplications(client.client.id)">
                                        <label>No active applications</label>
                                    </div> 
                                    <fieldset
                                        *ngIf="applications?.length > 0 && 
                                                anyInactiveClientApplications(client.client.id) &&
                                                _userAdminService && _userAdminService.ClientsWithApplications &&
                                                _userAdminService.ClientsWithApplications.length > 0 && 
                                                _userAdminService.ClientsWithApplications[client.index] && 
                                                _userAdminService.ClientsWithApplications[client.index].clientApplications">
                                        <legend>Pending</legend>
                                        <div *ngFor="let application of applications; let ind= index ">
                                            <div *ngFor="let clientAppModel of _userAdminService.ClientsWithApplications[client.index].clientApplications;">
                                                <div
                                                    *ngIf="application.id == clientAppModel.applicationId && 
                                                    !clientAppModel.isActive && 
                                                    clientAppModel.isPurchased && 
                                                    application.id != 0 && checkUserApplicationMappingStatus(clientAppModel.clientId, application.id)">
                                                    <label class="compact application list"
                                                        for="{{'pendingApplicationId' + ind}}">
                                                        <input #newUserApp
                                                            [formControlName]="getApplicationControlName(client.client.id, application.id)"
                                                            [id]="getApplicationControlName(client.client.id, application.id)"
                                                            (change)="userApplicationChecked(newUserApp, undefined, clientAppModel, cIndex)"
                                                            [value]="application.id" type="checkbox"
                                                            [checked]="isApplicationChecked(clientAppModel)">
                                                        {{ application.name }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
